/**
 * Минимальная часть описания колонок, не зависящая от реализации компонента таблицы.
 */
import * as React from "react";

type ColumnVisibilityMode = "alwaysVisible" | "defaultHidden";
export type ColumnKey = string;

export interface ColumnPoor {
  key: ColumnKey;
  title?: React.ReactNode;
  visibility?: ColumnVisibilityMode;
  width?: number | string;
  condition?(): boolean;
  disabledDrag?: boolean;
}

export const canBeHidden = ({ title, visibility }: ColumnPoor): boolean =>
  !!title && visibility !== "alwaysVisible";

export const visibleFixedLeft = (
  columns: ColumnPoor[],
  store: {
    readonly fixedLeftRaw: number;
    isColumnVisible(key: ColumnKey): boolean;
  },
): number =>
  columns
    .slice(0, store.fixedLeftRaw)
    .filter((col) => store.isColumnVisible(col.key)).length;
